import React, { useState, useRef, useEffect } from 'react'
import classNames from 'classnames';
import './index.scss';

interface IContentProps {
  contentText: string;
}


export default function CollapseContent(props: IContentProps) {
  const { contentText } = props;
  const [showMore, setShowMore] = useState(false);
  const [textExpanded, setTextExpanded] = useState(false);
  const hiddenTextRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!hiddenTextRef.current) return;
    const offsetWidth = hiddenTextRef.current.offsetWidth;
    if (offsetWidth > 190) {
      console.log('超长了~');
      setShowMore(true);
    }
  }, []);

  const onTapShowMore = () => {
    if (!showMore) return;
    setTextExpanded(preState => !preState);
  }

  return (
    <div
      className={classNames("collapse-content", {
        'content-expanded': textExpanded
      })}
      style={{ overflow: 'hidden' }}
      onClick={onTapShowMore}
    >
      <div
        className={classNames("content-text", {
          'expand-text': textExpanded
        })}
      >
        {contentText}
      </div>
      <div className="icon-side">
        {
          showMore && (
            <i
              className={classNames("arrow-down-icon", {
                'expanding': textExpanded
              })}
            />
          )
        }
      </div>
      <div className="hidden-content" ref={hiddenTextRef} >
        {contentText}
      </div>
    </div>
  )
}